import { render, staticRenderFns } from "./ViewComponent_v1_27_0.vue?vue&type=template&id=c6deac40&scoped=true"
import script from "./ViewComponent_v1_27_0.vue?vue&type=script&lang=js"
export * from "./ViewComponent_v1_27_0.vue?vue&type=script&lang=js"
import style0 from "./ViewComponent_v1_27_0.vue?vue&type=style&index=0&id=c6deac40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6deac40",
  null
  
)

export default component.exports